<template>
	<v-dialog v-model="localDialog" max-width="400px" transition="dialog-top-transition" persistent>
		<v-card>
			<v-card-title class="mx-auto primary2 py-1 font-size16 text-color-white">{{
				$t('deassign-license')
			}}</v-card-title>
			<v-card-text class="py-5"
				>{{ $t('confirmation-text') }}
				<div>
					{{ patientName }}
				</div>
			</v-card-text>
			<v-card-actions class="d-flex justify-center">
				<v-btn @click="deAssignLicenseForPatient" color="primary2" class="text-color-white">{{ $t('yes') }}</v-btn>
				<v-btn @click="closeDialog">{{ $t('no') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapState } from 'vuex';

export default {
	props: ['patientDialog', 'licenseId', 'patientName'],
	name: 'DeAssignLicenseConfirmationDialog',
	data () {
		return {
			localDialog: this.patientDialog,
		};
	},
	computed: {
		...mapState({
			userData: (state) => state.authentication.userData,
		}),
	},
	methods: {
		async getPatients () {
			this.loading = true;
			await this.$store.dispatch('hospitals/getRelatedPatientsV4', this.userData.hospitalAssignedData.id).then(() => {
				this.loading = false;
			});
		},
		getLicenses () {
			this.loading = true;
			this.$store.dispatch('licenses/getLicenses').then((res) => {
				this.loading = false;
			});
		},
		async deAssignLicenseForPatient () {
			try {
				const body = {
					licenseAssignmentId: this.licenseId,
				};
				await this.$store.dispatch('licenses/deassignLicenseForPatient', body).then((res) => {
					// because its the same component for the patient / licence different checks needs to me made.
					// We are calling here the patient list, not the licenses.

					switch (this.$route.path) {
						case '/licenses':
							this.getLicenses();
							break;
						case '/patients':
							this.getPatients();
							break;
					}

					this.closeDialog();
				});
			} catch (error) {
				return error;
			}
		},
		closeDialog () {
			this.localDialog = false;
		},
	},
	watch: {
		patientDialog (val) {
			this.localDialog = val;
		},
		localDialog (val) {
			this.$emit('update:patientDialog', val);
		},
	},
};
</script>
